import { legalListItem } from './legalListItem';

export enum LEGAL_LIST_THEME_KEYS {
  ITEM = 'LegalList/legalListItem',
}
export const LegalListTheme = {
  [LEGAL_LIST_THEME_KEYS.ITEM]: legalListItem,
};
